var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfiguration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Configuration_-_Flaticon-2",
    "data-name": "Search results for Configuration - Flaticon-2",
    transform: "translate(-2 -2)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Config",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9322",
    "data-name": "Path 9322",
    d: "M21,4.667H17.291L15.536,2.911a.333.333,0,0,0-.471,0L13.9,4.072c-.08-.036-.159-.067-.237-.1V2.333A.333.333,0,0,0,13.333,2H10.667a.333.333,0,0,0-.333.333v1.64c-.078.03-.157.062-.237.1L8.936,2.911a.343.343,0,0,0-.471,0L6.709,4.667H3a1,1,0,0,0-1,1V17a1,1,0,0,0,1,1H9.667v1.333H8.333a1,1,0,0,0-1,1v1.333A.333.333,0,0,0,7.667,22h8.667a.333.333,0,0,0,.333-.333V20.333a1,1,0,0,0-1-1H14.333V18H21a1,1,0,0,0,1-1V5.667a1,1,0,0,0-1-1ZM8.7,3.618,9.791,4.709a.333.333,0,0,0,.385.062,4.108,4.108,0,0,1,.591-.244A.333.333,0,0,0,11,4.21V2.667h2V4.21a.333.333,0,0,0,.233.318,4.108,4.108,0,0,1,.592.244.333.333,0,0,0,.385-.062L15.3,3.618l1.415,1.415-.731.731h0l-.36.36a.333.333,0,0,0-.062.385,4.109,4.109,0,0,1,.244.592.333.333,0,0,0,.318.233h1.543v2H14.474a2.667,2.667,0,1,0-4.947,0H6.333v-2H7.877A.333.333,0,0,0,8.194,7.1a4.109,4.109,0,0,1,.244-.592.333.333,0,0,0-.062-.385l-.36-.36h0l-.731-.73ZM7.738,6.43c-.036.08-.067.158-.1.237H6A.333.333,0,0,0,5.667,7V9.333h-1a.333.333,0,0,0,0,.667H19.333a.333.333,0,1,0,0-.667h-1V7A.333.333,0,0,0,18,6.667H16.36c-.03-.078-.062-.157-.1-.237l.1-.1h3.975v8H3.667v-8H7.642ZM10,8.333a2,2,0,1,1,4,0,1.967,1.967,0,0,1-.275,1H10.275A1.967,1.967,0,0,1,10,8.333Zm-7-3H6.642l.333.333H3.333A.333.333,0,0,0,3,6v8.667A.333.333,0,0,0,3.333,15H20.667A.333.333,0,0,0,21,14.667V6a.333.333,0,0,0-.333-.333H17.025l.333-.333H21a.333.333,0,0,1,.333.333v9.667H2.667V5.667A.333.333,0,0,1,3,5.333ZM15.667,20a.333.333,0,0,1,.333.333v1H8v-1A.333.333,0,0,1,8.333,20Zm-2-.667H10.333V18h3.333Zm7.333-2H3A.333.333,0,0,1,2.667,17V16H21.333v1A.333.333,0,0,1,21,17.333Z",
    transform: "translate(-2 -2)",
    fill: "#cdbfd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9323",
    "data-name": "Path 9323",
    d: "M53,45h-.667a.333.333,0,0,0,0,.667H53A.333.333,0,1,0,53,45Z",
    transform: "translate(-35.333 -30.667)",
    fill: "#cdbfd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9324",
    "data-name": "Path 9324",
    d: "M9.333,28.333h1.728a.994.994,0,0,0,1.877,0H24a.333.333,0,1,0,0-.667H12.939a.994.994,0,0,0-1.877,0H9.333a.333.333,0,1,0,0,.667ZM12,27.666a.333.333,0,1,1-.333.333A.333.333,0,0,1,12,27.666Z",
    transform: "translate(-6.667 -18.666)",
    fill: "#cdbfd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9325",
    "data-name": "Path 9325",
    d: "M9.333,33.333h4.061a.994.994,0,0,0,1.877,0H24a.333.333,0,1,0,0-.667H15.272a.994.994,0,0,0-1.877,0H9.333a.333.333,0,0,0,0,.667Zm5-.667A.333.333,0,1,1,14,33,.333.333,0,0,1,14.333,32.666Z",
    transform: "translate(-6.667 -21.999)",
    fill: "#cdbfd3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguration);
export default __webpack_public_path__ + "static/media/configuration.675a7ba19fdd3c2b28bbb10f7c557916.svg";
export { ForwardRef as ReactComponent };